import moment from "moment";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import LocationMark from "../Icons/LocationMark";

const LiveClock = () => {
    const [currentTime, setCurrentTime] = useState(moment());
    const userDetails = useSelector((state) => state.root.userDetails);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(moment()); // Use moment for consistency
        }, 1000);

        return () => clearInterval(timer); // Cleanup on unmount
    }, []);
    return (
        <>
            <h2>{currentTime.format("hh:mm:ss A")}</h2>
            <p>{currentTime.format("MMM DD, YYYY - dddd")}</p>
            <p className="fs-5">Shift Time: {moment(userDetails?.Shift?.startTime, 'HH:mm:ss').format('hh:mm A')} - {moment(userDetails?.Shift?.endTime, 'HH:mm:ss').format('hh:mm A')}</p>
            <p className="fs-4">
                <LocationMark />
                {userDetails?.office?.name?.toUpperCase() || "No Office Available"} - <span className="fs-5 ">{userDetails?.office?.address}</span>
            </p>
        </>
    );
};

export default LiveClock;
